import request from '@/service/request';

export const getShareInfo = ({
  productType,
  shareId,
}: {
  productType: string;
  shareId: string;
}) => {
  return request(
    `/v1/shaft/public/class/ips/vn/${productType}/quotation/share_info/${shareId}`,
  );
};

export const getPlanCmsDetail = ({
  productType,
  productId,
  planId,
}: {
  productType: string;
  productId: any;
  planId: string;
}) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productId}/plans/cms/${planId}`,
  );
};
